/**
 * Copyright (c) 2017-present, Tomaruba, Inc.
 * All rights reserved.
 *
 */
import { ReduceStore } from 'flux/utils'
import { List } from 'immutable'
import AppDispatcher from '../../core/AppDispatcher'
import { AutoMailActionTypes } from '../../action/auto_action/AutoMailActions'
import { AutoTaskActionTypes } from '../../action/auto_action/AutoTaskActions'
import RoomOptionState from './state/RoomOptionState'
import UserEvent from '../../event/UserEvent'
import SelectOptionEvent from '../../event/SelectOptionEvent'

class RoomOptionsStore extends ReduceStore {
  constructor() {
    super(AppDispatcher)
  }

  getInitialState() {
    return List([])
  }

  reduce(state, action) {
    const payload = action.payload

    switch (action.type) {
      // TODO ひとつにまとめる
      case SelectOptionEvent.fetchRooms:
      case UserEvent.fetchUserRooms:
      case AutoMailActionTypes.fetchRooms:
      case AutoTaskActionTypes.fetchRooms:
        const rooms = payload.rooms.map(room => {
          return new RoomOptionState().mergeModel(room)
        })
        return List(rooms)

      default:
        return state
    }
  }
}

export default new RoomOptionsStore()
